import { FC, useEffect, useState } from 'react';
import { TbCircleCheckFilled, TbInfoCircle, TbMailShare } from 'react-icons/tb';
import { useLocation } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { CONTACT_EMAILS, EMAIL_LINKS } from '@/shared/constants/externalLinks';
import { useBillingStore } from '@/stores/database/aliases/billing';

import PlatformAlert from '../PlatformAlert';

// interface SuccessfulCheckoutAlertProps {}

const SuccessfulCheckoutAlert: FC = ({}): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    // Plan Purchase Success
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const isSuccess = queryParams.get('success') === 'true';
    const refreshBillingSnapshot = useBillingStore((state) => state.refreshSnapshot);

    useEffect(() => {
        if (isSuccess) {
            void refreshBillingSnapshot();
        }
    }, [isSuccess, refreshBillingSnapshot]);

    return isSuccess ? (
        <div style={{ marginBottom: '1rem' }}>
            <PlatformAlert
                icon={<TbCircleCheckFilled />}
                showIcon
                type='success'
                message='Your checkout was successful!'
                description={
                    <span>
                        Thank you for continuing to use Countercyclical!
                        <div style={{ marginTop: '0.25rem' }}>
                            If you aren't seeing your plan update or being properly redirected after checkout, please
                            try logging out and back in again. Thank you for your patience!
                        </div>
                    </span>
                }
            />
            <div style={{ marginTop: '0.5rem' }}>
                <small>
                    <span style={{ color: token.colorTextTertiary }}>
                        <TbInfoCircle style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
                        If your plan still hasn't updated after logging back in, please contact us at{' '}
                    </span>
                    <a href={EMAIL_LINKS.billing}>
                        {CONTACT_EMAILS.billing}
                        <TbMailShare style={{ verticalAlign: '-0.1rem', marginLeft: '0.125rem' }} />
                    </a>
                </small>
            </div>
        </div>
    ) : (
        <></>
    );
};

export default SuccessfulCheckoutAlert;
